/**
 * デジタルサイネージ用の基底モジュール。
 * @module app/signage/_SignageBase
 */
define([
    'module',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/topic',
    'idis/control/Locator',
    'idis/view/page/_PageBase',
    // 以下、変数で受けないモジュール
    'dijit/form/Form',
    'dijit/form/Select',
    'dijit/form/Textarea',
    'dijit/form/TextBox',
    'idis/view/form/AclButton',
    'idis/view/form/Button'
], function (module, declare, lang, topic, Locator, _SignageBase) {

    return declare(module.id.replace(/\//g, '.'), _SignageBase,
        {
            // 画面ID
            _screenId: null,

            // 通知音
            audioData: null,

            /**
             * 地図のベースになるレイヤー
             * @type {String}
             */
            MUNICIPALITY_LAYER_URL: '/data/master/municipalities.geojson',

            constructor: function () {
                this._screenId = Locator.getQuery().screenId;
            },

            buildRendering: function () {
                this.inherited(arguments);
            },

            startup: function () {
                this.inherited(arguments);

                // audioデータをスタートアップ時に取得し流せるように準備する。
                if (!this.audioData) {
                    this.audioData = new Audio('/data/sound/sound1.mp3');
                    this.audioData.load();
                }

            },

            /**
             * 通知音を再生
             */
            playAudio: function () {
                this.audioData.play().catch(function (error) {
                    console.error('音声の再生に失敗しました。', error);
                });
            },

            /**
                 * 地図レイヤーの上に行政界レイヤーを敷く
                 * 県の境が見にくいため、自治体ごとのpolygonを置いている.
                 * layeridの'999'は仮
                 * TODO: 将来的にURLで制御させるか検討要
                 */
            putFirstLayer: function () {
                return this.map.layerControl.addGeneralLayer({
                    'id': 999,
                    'name': '行政界',
                    'parentId': 0,
                    'disasterId': 21,
                    'dispSeqNo': 2,
                    'infoCategoryCd': 'D108',
                    'pubStatus': '9',
                    'deptCd': 'D01001',
                    'sectCd': 'S01003',
                    'minZoom': 8,
                    'tileFlg': false,
                    'jsonType': '1',
                    'listType': '0',
                    'layerUrl': this.MUNICIPALITY_LAYER_URL,
                    'styleUrl': 'style.js',
                    'hideFlg': false,
                    'userId': 'U01001'
                }, 1);
            },

            /**
             * 警戒レベルありの発令理由かどうかを判定する
             */
            hasWarningLevel: function (item) {
                return ['01', '02', '05'].includes(item.issueReasonType);
            },

            /**
             * 避難内容ごとの設定
             */
            evacOrderConfig: {
                // 高齢者避難
                '11': {
                    label: '高齢者避難',
                    color: '#FF2800',
                    className: 'prepare',
                    level: 3
                },
                // 避難指示
                '13': {
                    label: '避難指示',
                    color: '#AA00AA',
                    className: 'order',
                    level: 4
                },
                // 緊急安全確保
                '14': {
                    label: '緊急安全確保',
                    color: '#0C000C',
                    className: 'occur',
                    level: 5
                }
            },

            /**
             * 避難発令理由 コード→名称変換
             */
            issueReasonTypeLabel: {
                '01': '土砂',
                '02': '洪水',
                '03': '地震',
                '04': '津波',
                '05': '高潮',
                '06': '火災',
                '07': '暴風',
                '08': '火山',
                '09': '国民保護',
                '00': 'その他',
            }

        });
});
